export const SHOW_TOAST_REQUEST = '@toast/SHOW_TOAST_REQUEST';
export const SHOW_TOAST_SUCCESS = '@toast/SHOW_TOAST_SUCCESS';
export const SHOW_TOAST_FAILURE = '@toast/SHOW_TOAST_FAILURE';